import "./RemoveNoteGroup.scss";
import { useTranslation, Trans } from "react-i18next";

function RemoveNoteGroup({
  cancelRemoveNoteGroup,
  removeNoteGroup,
  noteGroupName,
  noteCount = 0,
}) {
  const { t } = useTranslation();
  return (
    <div className="remove-notegroup-content">
      <div className="modal-title">
        <div>{t("notes.modals.removeGroup.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("notes.modals.removeGroup.message", { name: noteGroupName })}</p>
        <p className="warning-text">
          {noteCount > 0 ? (
            <Trans
              i18nKey="notes.modals.removeGroup.warningNotes"
              count={noteCount}
              components={{ bold: <strong /> }}
            />
          ) : (
            t("notes.modals.removeGroup.warningEmpty")
          )}
        </p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveNoteGroup}>
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeNoteGroup}>
          {t("common.remove")}
        </button>
      </div>
    </div>
  );
}

export default RemoveNoteGroup;
